var _path, _rect, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "highlight-stroke",
    d: "M7 24.2963L4 22.6667V18.963M4 13.037V9.33332L7 7.70369M13 4.29629L16 2.66666L19 4.29629M25 7.70369L28 9.33332V13.037M28 18.963V22.6667L25 24.3259M19 27.7037L16 29.3333L13 27.7037M16 16L19 14.3704M25 10.963L28 9.33332M16 16V19.7037M16 25.6296V29.3333M16 16L13 14.3407M7 10.963L4 9.33332",
    stroke: "#090909",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#F2F2F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "highlight-fill",
    d: "M16.2732 18L14.3052 12.664H12.2732L10.3052 18H12.1372L12.3292 17.376H14.2492L14.4412 18H16.2732ZM13.8172 15.968H12.7612L13.2892 14.248L13.8172 15.968ZM21.3369 18L20.3689 16.112C20.7929 15.904 21.3289 15.416 21.3289 14.496C21.3289 13.496 20.6569 12.664 19.4089 12.664H16.5609V18H18.1769V16.32H18.7609L19.4969 18H21.3369ZM19.1609 14.912H18.1769V14.072H19.1609C19.4329 14.072 19.6889 14.2 19.6889 14.488C19.6889 14.784 19.4329 14.912 19.1609 14.912Z",
    fill: "#090909"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAr);
export default __webpack_public_path__ + "static/media/ar.a61073fa40958f6767b6297bfe385d1e.svg";
export { ForwardRef as ReactComponent };